/*
 * @Description: 案例审核图片模式
 * @Author: hanpengtao
 * @Date: 2022-04-26 09:12:01
 */
import React, { useMemo, useState } from 'react';
import { Modal, Button } from 'antd';
import classnames from "classnames";
import './index.less';

import { imgSuffixWidth } from '../../../../util/inspiration';

const PictureMode = (props) => {
  const { caseData, imgList, setImgList, wrapClassName } = props;

  const [showImgUrl, setShowImgUrl] = useState('');
  const [showBigImg, setShowBigImg] = useState(false);

  const imgCount = useMemo(()=>{
    return imgList.filter(x => !x.isDelete).length
  },[imgList])
  const handleCover = (currentItem) => {
    setImgList(
      imgList.map(item => ({
        ...item,
        isCover: currentItem.id === item.id,
      }))
    )
  }

  const handleDelete = (currentItem) => {
    setImgList(
      imgList.map(item => ({
        ...item,
        isDelete: !item.isCover && currentItem.id === item.id
          ? !currentItem.isDelete
          : item.isDelete,
      }))
    )
  }

  const checkBigImg = (imgUrl) => {
    setShowBigImg(true);
    setShowImgUrl(imgUrl);
  }

  const handleImgCancel = () => {
    setShowBigImg(false);
  }

  return (
    <div className={classnames('pictureMode', wrapClassName)}>
      <div className='header'>
        <div>{caseData?.caseInfo?.titleOrigin}</div>
        <div className='picNum'>
          图片数量：<span className='blue'>
          {imgCount}
          </span>张
        </div>
      </div>
      <div className='caseImgList'>
        {imgList?.map((item, index) => item.isDelete ? <></> : (
          item.imgUrl && <div className='imgCon' key={item.id}>
            <img
              className='caseImg'
              src={item.imgUrl + imgSuffixWidth(280, 340)}
              onClick={() => checkBigImg(item.imgUrl)}
              alt=""
            />

            {!item.isDelete && (
              <Button className='cover' onClick={() => handleCover(item)}>
                {item.isCover ? '封面图' : '设为封面'}
              </Button>
            )}

            {!item.isCover && !item.isOriginalCover && (
              <Button className='delete' onClick={() => handleDelete(item)}>
                {item.isDelete ? '取消' : '删除'}
              </Button>
            )}

            {item.isDelete && <div className='imgModal'></div>}
          </div>
        ))}
      </div>

      <Modal
        width='1200px'
        height='1000px'
        visible={showBigImg}
        wrapClassName='img_modal'
        onCancel={handleImgCancel}
        footer={null}
      >
        <img src={showImgUrl} alt="" />
      </Modal>
    </div>
  )
}

export default PictureMode;